import React from 'react';

import type { SVGProps } from 'react';

export const TelephoneOutgoingIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.65387 1.32849C3.40343 1.00649 2.92745 0.976861 2.639 1.26531L1.60508 2.29923C1.1216 2.78271 0.943869 3.46766 1.1551 4.06847C2.00338 6.48124 3.39215 8.74671 5.32272 10.6773C7.25329 12.6078 9.51876 13.9966 11.9315 14.8449C12.5323 15.0561 13.2173 14.8784 13.7008 14.3949L14.7347 13.361C15.0231 13.0726 14.9935 12.5966 14.6715 12.3461L12.3653 10.5524C12.2008 10.4245 11.9866 10.3793 11.7845 10.4298L9.59541 10.9771C9.00081 11.1257 8.37183 10.9515 7.93845 10.5181L5.48187 8.06155C5.04849 7.62817 4.87427 6.99919 5.02292 6.40459L5.57019 4.21553C5.62073 4.01336 5.57552 3.79918 5.44758 3.63468L3.65387 1.32849ZM1.88477 0.511076C2.62689 -0.231038 3.8515 -0.154797 4.49583 0.673635L6.28954 2.97983C6.6187 3.40304 6.73502 3.95409 6.60498 4.47423L6.05772 6.66329C5.99994 6.8944 6.06765 7.13888 6.2361 7.30732L8.69268 9.7639C8.86113 9.93235 9.1056 10.0001 9.33671 9.94229L11.5258 9.39502C12.0459 9.26499 12.597 9.38131 13.0202 9.71047L15.3264 11.5042C16.1548 12.1485 16.231 13.3731 15.4889 14.1152L14.455 15.1492C13.7153 15.8889 12.6089 16.2137 11.5777 15.8512C9.01754 14.9511 6.61438 13.4774 4.56849 11.4315C2.52259 9.38562 1.04895 6.98246 0.148837 4.42225C-0.213683 3.39112 0.11113 2.28472 0.85085 1.545L1.88477 0.511076Z"
      fill="currentColor"
    />
    <path
      d="M11 0.5C11 0.223858 11.2239 2.13986e-07 11.5 2.62268e-07L15.5 9.61651e-07C15.7761 1.00993e-06 16 0.223859 16 0.500001L16 4.5C16 4.77614 15.7761 5 15.5 5C15.2239 5 15 4.77614 15 4.5L15 1.70711L10.8536 5.85355C10.6583 6.04882 10.3417 6.04882 10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645L14.2929 1L11.5 1C11.2239 1 11 0.776143 11 0.5Z"
      fill="currentColor"
    />
  </svg>
);
